import { render, staticRenderFns } from "./external-auth.vue?vue&type=template&id=6af9cf6a&scoped=true&"
import script from "./external-auth.component.ts?vue&type=script&lang=ts&"
export * from "./external-auth.component.ts?vue&type=script&lang=ts&"
import style0 from "./external-auth.vue?vue&type=style&index=0&id=6af9cf6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af9cf6a",
  null
  
)

export default component.exports